export default __webpack_public_path__ + "static/media/fad-modsawdown.1ac62829.svg";